import type { LoginResponse, SurveyUserSession } from '@ferty9/types';

const SESSION_KEY = 'ferty9_user';

export function toSurveySession(loginResponse: LoginResponse): SurveyUserSession {
  return {
    token: loginResponse.token,
    name: loginResponse.user.username,
    center_name: loginResponse.user.center_name,
    role: loginResponse.user.role,
    is_superadmin: loginResponse.user.is_superadmin,
    isRootAdmin: loginResponse.user.isRootAdmin,
    permissions: loginResponse.user.permissions,
  };
}

export function getSurveySession(): SurveyUserSession | null {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(SESSION_KEY);
  if (!value) return null;
  return JSON.parse(value) as SurveyUserSession;
}

export function setSurveySession(session: SurveyUserSession): void {
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function setSurveySessionFromLogin(loginResponse: LoginResponse): SurveyUserSession {
  const session = toSurveySession(loginResponse);
  setSurveySession(session);
  return session;
}

export function clearSurveySession(): void {
  window.sessionStorage.removeItem(SESSION_KEY);
  window.localStorage.removeItem(SESSION_KEY);
}
